import React, { Component, ErrorInfo, ReactNode } from 'react';
import Container from '@/shared/Container';
import Div from '@/shared/Div';
import Button from '@/shared/Button';
import Heading from '@/shared/Heading';
import Paragraph from '@/shared/Paragraph';
import Fonts from '../Fonts';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: any, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  private backToHome = () => {
    const previousUrl = document.referrer;
    if (previousUrl && previousUrl !== window.location.href) {
      window.location.href = previousUrl;
    } else {
      window.location.href = '/';
    }
  };

  public render() {
    if (this.state.hasError) {
      return (
        <Container className="flex items-center justify-center h-screen font-primary">
          <Fonts />
          <Div className="text-center flex flex-col gap-s6 border rounded-cs p-s6 ">
            <Heading className="text-cti-primary text-h-2 md:text-hd-2">
              Something went wrong!
              <Paragraph className="text-cti-secondary mt-s3">
                Please go back to the homepage or reload the page to try again.
              </Paragraph>
            </Heading>
            <Div className="flex gap-s4">
              <Button theme="secondary" size="sm" className="w-full" onClick={this.backToHome}>
                Back
              </Button>
              <Button size="sm" className="w-full" onClick={() => location.reload()}>
                Reload
              </Button>
            </Div>
          </Div>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
